import { useState, useEffect } from "react";
import { useSessionStorage } from "utils";
import PlaidLinkWrapper from "./PlaidLinkWrapper";
import ErrorViewAndRedirect from "./ErrorViewAndRedirect";
import { usePlaidLink } from "react-plaid-link";

const OAuthSuccess = () => {
  const [receivedRedirectUri] = useState(window.location.href);
  const [plaidLinkToken] = useSessionStorage("tilia.ac.plink"); // this should be set by the AddPlaidACHButton component before redirecting
  const [err, setErr] = useState(null);
  useEffect(() => {
    try {
      const url = new URL(receivedRedirectUri);
      const oauthStateID = url.searchParams.get("oauth_state_id"); // this is required by Plaid when returning from the OAuth flow
      if (!oauthStateID) {
        setErr(new Error("Missing oauth_state_id parameter."));
      }
    } catch (error) {
      setErr(new Error(error.message || "Error parsing oauth_state_id from url.")); // since error in this case is not an instanceof Error (URL error fires off something different), re-casting as Error object for EmptyState controller
    }
  }, [receivedRedirectUri, setErr]);
  let content;
  if (err) {
    content = <ErrorViewAndRedirect error={err} />;
  } else {
    content = (
      <PlaidLinkWrapper
        plaidLinkToken={plaidLinkToken}
        receivedRedirectUri={receivedRedirectUri}
        usePlaidLink={usePlaidLink}
      />
    );
  }
  return <span data-testid="plaid-success">{content}</span>;
};

export default OAuthSuccess;
